import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { createTheme } from "@mui/material/styles";


import PaddedContentArea from "../../common/PaddedContentArea";
import HomeCalendar from "./Components/HomeCalendar";
import YourDayBanner from "./Components/YourDayBanner";
import ActivityTrackerV3 from "./Components/ActivityTrackerV3";
import ChallengeTrackerV2 from "./Components/ChallengeTrackerV2";
import WorkoutHistory from "./Components/WorkoutHistory";

import {
    CheckRequirementsAndRedirectV2, GetAllWorkOutHistories, GetWorkOutHistory,
    GetAllWorkOutHistoriesWithArchived, GetSelectionHistory, LoadAccountDetails
} from "../../redux/v2/user/actions";
import { GetWholeWorkoutByProgram } from "../../redux/v2/workout/actions";
import { GetPrograms, GetSuggestedPrograms2 } from "../../redux/v2/program/actions";
import { GetChallenges } from "../../redux/v2/challenge/actions";
import { ScreenType } from "../../utils/breakpoints";

import useWorkoutPlan from "../../hooks/useWorkoutPlan";
import useDate from "../../hooks/useDate";

import "./style.css";

function HomeContent(props) {

    const navigate = useNavigate();
    const theme = createTheme({
        breakpoints: {
            values: {
                desktop: 1025,
            },
        },
    });
    const isDesktop = useMediaQuery(theme.breakpoints.up("desktop"));
    const screenSize = ScreenType(useMediaQuery);
    const { account, workoutHistory, allWorkoutHistory } = props.User;
    const { programs } = props.Program;
    // const { groupedWorkouts } = props.Workout;
    const { workoutPlan } = useWorkoutPlan({ account, programs });


    const [weekProgress, setWeekProgress] = useState(0);
    const [groupedWorkouts, setGroupedWorkouts] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateSchedule, setSelectedDateSchedule] = useState(null);
    const [pointDate, setPointDate] = useState(null);
    const [allWorkouts, setAllWorkouts] = useState(null);

    const { GetCalendarMatrixV2, calendarMatrix } = useDate({
        workoutPlan: workoutPlan?.schedule || {}, pointDate: pointDate, groupedWorkouts: groupedWorkouts, workoutHistory: allWorkoutHistory, programs
    });
    const calendar = calendarMatrix;
    // const calendar = GetCalendarMatrixV2(workoutPlan?.schedule || {}, pointDate, groupedWorkouts);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];

    console.log("workoutPlan?.schedule", workoutPlan?.schedule);
    console.log("onboardingDetail", onboardingDetail);
    console.log("calendarMatrix", calendarMatrix);
    console.log("groupedWorkouts", groupedWorkouts);

    useEffect(() => {
        if (account?.user?.id) {
            props.CheckRequirementsAndRedirectV2(navigate);
            props.GetWorkOutHistory();
            props.GetAllWorkOutHistories();
            props.GetAllWorkOutHistoriesWithArchived();
            props.GetSelectionHistory();
            props.GetChallenges("active");
            props.GetPrograms();
            props.GetSuggestedPrograms2();
        } else {
            props.LoadAccountDetails();
        }
    }, [account]);

    useEffect(() => {
        const cb = async () => {
            if (onboardingDetail?.created_at) {
                const wpPrograms = onboardingDetail?.programs?.split(",") || [];
                // console.log("wpPrograms", wpPrograms);
                let temp = [], allWorkoutsTemp = [], tempGroupedWorkouts = [];
                for (let x = 0; x < wpPrograms.length; x++) {
                    temp = wpPrograms[x]?.split("-");
                    const programId = temp?.[0] * 1;
                    const programLevel = (temp?.[1] || 0) * 1;
                    const workouts = await props.GetWholeWorkoutByProgram(programId, programLevel, true);

                    // console.log("works", workouts);
                    allWorkoutsTemp = [...allWorkoutsTemp, ...workouts];

                    const key = "prog-" + programId + (programLevel ? ("-" + programLevel) : "");
                    tempGroupedWorkouts[key] = [...workouts];
                }

                setGroupedWorkouts(tempGroupedWorkouts);
                setAllWorkouts(allWorkoutsTemp);
                setPointDate(onboardingDetail?.created_at);
            }
        }

        cb();

    }, [onboardingDetail?.created_at]);

    useEffect(() => {
        // remove workouts that are already in workout history
        if (allWorkouts?.length && allWorkoutHistory?.length) {
            const filteredWorkouts = allWorkouts.filter((workout) => {
                return !allWorkoutHistory.some((history) => history.workout_id === workout.id);
            });
            setAllWorkouts(filteredWorkouts);
        }

    }, [allWorkouts?.length, allWorkoutHistory?.length]);

    useEffect(() => {
        if (calendarMatrix?.dateAfterEndDate?.day) {
            const { year, month, day } = calendarMatrix?.dateAfterEndDate;
            const date = new Date(year, (month * 1) - 1, day * 1);
            const now = new Date();

            if (now >= date) {
                navigate("/user-survey");
            }

        }
    }, [calendarMatrix?.dateAfterEndDate?.day]);



    return (
        <div id="home">

            <div className="row">
                <div className={`col-md-${isDesktop ? "6" : "12"} home-left`}>
                    <HomeCalendar workoutPlan={workoutPlan} calendar={calendar} setSelectedDate={setSelectedDate} setSelectedDateSchedule={setSelectedDateSchedule} isDesktop={isDesktop} />
                    <YourDayBanner workoutPlan={workoutPlan} selectedDate={selectedDate} selectedDateSchedule={selectedDateSchedule} calendar={calendar} />
                </div>
                <div className={`col-md-${isDesktop ? "6" : "12"} home-right`}>
                    <PaddedContentArea>
                        <ActivityTrackerV3
                            screenSize={screenSize}
                            setWeekProgress={(count) => {
                                if (count == 0) {
                                    setWeekProgress(0);
                                } else if (count > 0 && count < 3) {
                                    setWeekProgress(1);
                                } else {
                                    setWeekProgress(2);
                                }
                            }}
                        />

                        <ChallengeTrackerV2 />
                    </PaddedContentArea>
                </div>
                <div className="col-md-12 home-bottom">
                    <PaddedContentArea>
                        <WorkoutHistory screenSize={screenSize} />
                    </PaddedContentArea>
                </div>
                {/* {account.aaa.ddd} */}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
    Workout: state.Workout,
});

export default connect(mapStateToProps, {
    CheckRequirementsAndRedirectV2,
    GetPrograms,
    GetWorkOutHistory,
    GetAllWorkOutHistories,
    GetAllWorkOutHistoriesWithArchived,
    GetSelectionHistory,
    GetChallenges,
    LoadAccountDetails,
    GetSuggestedPrograms2,
    GetWholeWorkoutByProgram,
})(HomeContent);